import React, { Component } from "react";
import { Alert, Button } from "react-bootstrap";

const DISMISS_KEY = "mangusta-pwa-install-dismissed-at";
const DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;

function isInstalled() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

function isIosDevice() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent);
}

function wasRecentlyDismissed() {
  try {
    const dismissedAt = Number(window.localStorage.getItem(DISMISS_KEY));
    return dismissedAt > 0 && Date.now() - dismissedAt < DISMISS_DURATION_MS;
  } catch (error) {
    return false;
  }
}

class PwaInstallPrompt extends Component {
  state = {
    deferredPrompt: null,
    showIosInstructions:
      isIosDevice() && !isInstalled() && !wasRecentlyDismissed(),
    updateAvailable: false
  };

  componentDidMount() {
    window.addEventListener("beforeinstallprompt", this.handleInstallAvailable);
    window.addEventListener("appinstalled", this.handleInstalled);
    window.addEventListener("mangusta-pwa-update", this.handleUpdateAvailable);
  }

  componentWillUnmount() {
    window.removeEventListener(
      "beforeinstallprompt",
      this.handleInstallAvailable
    );
    window.removeEventListener("appinstalled", this.handleInstalled);
    window.removeEventListener(
      "mangusta-pwa-update",
      this.handleUpdateAvailable
    );
  }

  handleInstallAvailable = event => {
    event.preventDefault();
    if (isInstalled() || wasRecentlyDismissed()) return;
    this.setState({ deferredPrompt: event });
  };

  handleInstalled = () => {
    this.setState({
      deferredPrompt: null,
      showIosInstructions: false
    });
  };

  handleUpdateAvailable = () => {
    this.setState({ updateAvailable: true });
  };

  install = () => {
    const prompt = this.state.deferredPrompt;
    if (!prompt) return;
    prompt.prompt();
    prompt.userChoice.then(choice => {
      if (choice.outcome !== "accepted") this.rememberDismissal();
      this.setState({ deferredPrompt: null });
    });
  };

  rememberDismissal = () => {
    try {
      window.localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch (error) {
      // The banner is hidden for this page even if storage is unavailable.
    }
  };

  dismiss = () => {
    this.rememberDismissal();
    this.setState({
      deferredPrompt: null,
      showIosInstructions: false,
      updateAvailable: false
    });
  };

  reload = () => {
    window.location.reload();
  };

  render() {
    const {
      deferredPrompt,
      showIosInstructions,
      updateAvailable
    } = this.state;
    if (!deferredPrompt && !showIosInstructions && !updateAvailable)
      return null;

    return (
      <div
        style={{
          position: "fixed",
          left: 15,
          right: 15,
          bottom: 15,
          zIndex: 10000,
          maxWidth: 620,
          margin: "0 auto"
        }}
      >
        <Alert bsStyle={updateAvailable ? "warning" : "info"}>
          <button type="button" className="close" onClick={this.dismiss}>
            <span aria-hidden="true">&times;</span>
            <span className="sr-only">Zamknij</span>
          </button>
          {updateAvailable ? (
            <React.Fragment>
              <strong>Dostępna jest nowa wersja panelu.</strong>{" "}
              <Button bsStyle="warning" bsSize="small" onClick={this.reload}>
                Odśwież
              </Button>
            </React.Fragment>
          ) : showIosInstructions ? (
            <React.Fragment>
              <strong>Zainstaluj Mangusta24 na ekranie początkowym.</strong>
              <br />
              W Safari wybierz „Udostępnij”, a następnie „Do ekranu
              początkowego”.
            </React.Fragment>
          ) : (
            <React.Fragment>
              <strong>Zainstaluj panel Mangusta24 jako aplikację.</strong>{" "}
              <Button bsStyle="info" bsSize="small" onClick={this.install}>
                Zainstaluj
              </Button>
            </React.Fragment>
          )}
        </Alert>
      </div>
    );
  }
}

export default PwaInstallPrompt;



// WEBPACK FOOTER //
// ./src/components/PwaInstallPrompt/PwaInstallPrompt.jsx